var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents-group" },
    [
      _c("div", { staticClass: "documents-group__header" }, [
        _c(
          "div",
          { staticClass: "documents-group__data" },
          [
            _c("toggle-button", {
              staticClass: "documents-group__toggler",
              attrs: { disabled: _vm.noAnalysesInGroup },
              model: {
                value: _vm.isOpen,
                callback: function ($$v) {
                  _vm.isOpen = $$v
                },
                expression: "isOpen",
              },
            }),
            _c("div", { staticClass: "documents-group__info" }, [
              _c("div", { staticClass: "documents-group__name" }, [
                _vm._v(" " + _vm._s(_vm.group.name) + " "),
              ]),
              _vm.group.description
                ? _c("div", { staticClass: "documents-group__description" }, [
                    _vm._v(" " + _vm._s(_vm.group.description) + " "),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "documents-group__actions" },
          [
            _c("c-button-2", {
              staticClass: "documents-group__edit",
              attrs: {
                id: `medical-analyse-edit-button-${_vm.group.id}`,
                size: "iconic",
                icon: "edit",
              },
              on: { click: _vm.onEdit },
            }),
            _vm.group["analyses"].length > 0
              ? _c(
                  "span",
                  {
                    staticClass: "documents-group__remove",
                    attrs: { id: `document-group-remove-${_vm.group.id}` },
                  },
                  [
                    _c("c-button-2", {
                      attrs: {
                        id: `medical-analyse-remove-button-${_vm.group.id}`,
                        size: "iconic",
                        icon: { icon: "trash", color: "secondary" },
                        disabled: "",
                      },
                    }),
                  ],
                  1
                )
              : _c("c-button-2", {
                  staticClass: "documents-group__remove",
                  attrs: {
                    id: `medical-analyse-remove-button-${_vm.group.id}`,
                    size: "iconic",
                    icon: { icon: "trash", color: "secondary" },
                  },
                  on: { click: _vm.onRemove },
                }),
            _c("c-button-2", {
              staticClass: "documents-group__move",
              attrs: {
                id: `medical-analyse-sort-button-${_vm.group.id}`,
                size: "iconic",
                icon: "arrows-constructor",
              },
            }),
            _c(
              "b-popover",
              {
                attrs: {
                  placement: "top",
                  triggers: "hover blur",
                  container: "app",
                  boundary: "window",
                  target: `document-group-remove-${_vm.group.id}`,
                },
              },
              [
                _c("error-feedback", {
                  staticClass: "m-0 empty-category-tooltip",
                  attrs: {
                    text: "В данный момент удаление невозможно, так как тип анализа содержит данные. Сначала перенесите все данные из типа.",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-popover",
              {
                attrs: {
                  placement: "top",
                  triggers: "hover",
                  target: `medical-analyse-edit-button-${_vm.group.id}`,
                },
              },
              [_vm._v(" Редактировать ")]
            ),
            _c(
              "b-popover",
              {
                attrs: {
                  placement: "top",
                  triggers: "hover",
                  target: `medical-analyse-remove-button-${_vm.group.id}`,
                },
              },
              [_vm._v(" Удалить ")]
            ),
            _c(
              "b-popover",
              {
                attrs: {
                  placement: "top",
                  triggers: "hover",
                  target: `medical-analyse-sort-button-${_vm.group.id}`,
                },
              },
              [_vm._v(" Переместить ")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "slide-up-down",
        {
          staticClass: "documents-group__items",
          attrs: { active: _vm.isOpen || _vm.noAnalysesInGroup, duration: 400 },
        },
        [
          _c(
            "draggable",
            {
              staticClass: "item-sub item-container",
              attrs: {
                group: "type",
                list: _vm.group.analyses,
                move: _vm.onMove,
                "force-fallback": true,
                "ghost-class": "sortable__ghost",
              },
              on: { change: _vm.onSort, moving: _vm.onMovingElement },
            },
            _vm._l(_vm.group["analyses"], function (analyse) {
              return _c(
                "div",
                { key: analyse.id },
                [
                  _c("medical-analyse-group-item", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isAnalyseVisible(analyse),
                        expression: "isAnalyseVisible(analyse)",
                      },
                    ],
                    attrs: { analyse: analyse },
                    on: {
                      remove: function ($event) {
                        return _vm.onAnalyseRemove(analyse)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }